/**
 * Admin PIN — the tenant-wide PIN that (in the legacy 8x8 console) gates who may
 * change a space's settings. There is no backend for a Spaces admin PIN yet (no
 * endpoint, no contract), so this is designed but PLANNED: the modal previews the
 * intended UI with a clearly-labelled "not yet wired" notice and a disabled Save —
 * it never writes a fake/default PIN store.
 */

import { useState } from 'react';
import styled from 'styled-components';
import Modal, { ModalContent, ModalFooter, ModalHeader } from '@8x8/oxygen-modal';
import Button from '@8x8/oxygen-button';
import TextField from '@8x8/oxygen-text-field';
import { LockIcon } from '@8x8/oxygen-icon';
import { Notice } from '../ui/primitives';

const Trigger = styled.button`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    border: none;
    cursor: pointer;
    padding: 8px 12px;
    border-radius: 6px;
    background: transparent;
    color: ${p => p.theme.action08};
    font-size: 14px;
    font-weight: 600;

    &:hover {
        background: ${p => `${p.theme.action08}14`};
    }
`;

export function AdminPinButton(): JSX.Element {
    const [open, setOpen] = useState(false);

    return (
        <>
            <Trigger onClick={() => setOpen(true)} title="Spaces admin PIN">
                <LockIcon size={16} />
                Admin PIN
            </Trigger>

            {open ? (
                <Modal isVisible size="small" onClose={() => setOpen(false)} shouldCloseOnOverlayClick>
                    <ModalHeader title="Spaces admin PIN" onClose={() => setOpen(false)} />
                    <ModalContent>
                        <div style={{ padding: '4px 0 8px', display: 'flex', flexDirection: 'column', gap: 14 }}>
                            <div style={{ fontSize: 14, lineHeight: '21px' }}>
                                A tenant-wide PIN lets only admins who know it change a space&apos;s settings.
                                If someone wants to edit a space, they will need to provide the PIN.
                            </div>
                            <Notice kind="info">
                                Planned — not yet wired. The Spaces backend has no admin-PIN store yet, so this
                                preview is disabled rather than saving a placeholder PIN.
                            </Notice>
                            <TextField label="PIN" type="password" placeholder="Enter PIN" isDisabled fullWidth onChange={() => undefined} />
                        </div>
                    </ModalContent>
                    <ModalFooter>
                        <Button variant="secondary" onClick={() => setOpen(false)}>Close</Button>
                        <Button variant="primary" isDisabled>Save</Button>
                    </ModalFooter>
                </Modal>
            ) : null}
        </>
    );
}
